import { create } from 'zustand'

interface ActionsSharedState {
  actionsSettingsEnabled: boolean
  setActionsSettingsEnabled: (enabled: boolean) => void
}

export const useActionsSharedState = create<ActionsSharedState>((set) => ({
  actionsSettingsEnabled: true,
  setActionsSettingsEnabled: (enabled) => set({ actionsSettingsEnabled: enabled }),
}))
